import React from 'react'
import Typography from '@material-ui/core/Typography'

const PaperSubTitle = ({ title }) => {
    return <Typography variant="h6">{title}</Typography>
}

export default PaperSubTitle
